import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=255bb61b&scoped=true&"
import script from "./Modify.vue?vue&type=script&lang=js&"
export * from "./Modify.vue?vue&type=script&lang=js&"
import style0 from "@/assets/todomodify.css?vue&type=style&index=0&id=255bb61b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255bb61b",
  null
  
)

export default component.exports